import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocalizedPath } from "@/i18n/useLocalizedPath";
import { fadeUp, stagger, viewportOnce } from "./motion-presets";

export const FinalCTA = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("landing");
  const lp = useLocalizedPath();

  return (
    <section className="relative py-24 px-4 overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[320px] opacity-20 blur-3xl"
        style={{
          background:
            "radial-gradient(ellipse at center, hsl(var(--primary) / 0.5), transparent 70%)",
        }}
      />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={stagger}
        className="relative container mx-auto max-w-3xl text-center"
      >
        <motion.h2
          variants={fadeUp}
          className="font-display text-3xl md:text-5xl font-semibold tracking-tight text-foreground leading-[1.05]"
        >
          {t("finalCta.titleLine1")}
          <br />
          {t("finalCta.titleLine2")}
          <br />
          <span className="text-muted-foreground">{t("finalCta.titleLine3")}</span>
        </motion.h2>

        <motion.p variants={fadeUp} className="mt-6 text-lg text-muted-foreground">
          {t("finalCta.subtitle")}
        </motion.p>

        <motion.div variants={fadeUp} className="mt-8">
          <Button
            size="lg"
            onClick={() => navigate(lp("/auth") + "?mode=signup")}
            className="btn-gradient text-white border-0 h-11 px-7 gap-2"
          >
            {t("finalCta.cta")} <ArrowRight className="h-4 w-4" />
          </Button>
        </motion.div>

        <motion.p variants={fadeUp} className="mt-4 text-xs text-muted-foreground">
          {t("finalCta.trustedBy")}
        </motion.p>

        <motion.p variants={fadeUp} className="mt-6 text-sm">
          <button
            onClick={() => navigate(lp("/demo"))}
            className="text-muted-foreground underline underline-offset-4 hover:text-foreground transition-colors"
          >
            {t("finalCta.demoLink")}
          </button>
        </motion.p>
      </motion.div>
    </section>
  );
};
